import React from 'react';
import PropTypes from 'prop-types';
import Markdown from '../markdown';
import { stringSubstitution } from './util';
import CommonPropTypes from '../common-prop-types';
import { registerWidget } from './sections';

/**
 * @param {Object} props
 * @param {String} props.title
 * @param {String} props.headerClass
 * @param {String} props.className
 * @param {Object} props.stringSubstitutions
 */
const TextSection = ({
  className,
  headerClass,
  text,
  title,
  stringSubstitutions,
}) => {
  const titleElement = title ? (
    <h2 className={headerClass}>
      {stringSubstitution(title, stringSubstitutions)}
    </h2>
  ) : null;
  return (
    <div className={`TextSection ${className}`}>
      { titleElement }
      <Markdown className='paragraph' source={stringSubstitution(text, stringSubstitutions)} />
    </div>
  );
};

export const textSectionPropTypes = {
  className: PropTypes.string,
  headerClass: PropTypes.string,
  stringSubstitutions: CommonPropTypes.stringSubstitutions,
  text: PropTypes.string.isRequired,
  title: PropTypes.string,
};

TextSection.propTypes = textSectionPropTypes;

TextSection.defaultProps = {
  className: '',
  headerClass: 'h2',
  stringSubstitutions: {},
  title: null,
};

registerWidget('textSection', TextSection);

export default TextSection;
